<template>
  <div class="list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams">
        <!-- 区域 -->
        <el-form-item label="区域">
          <el-select
            filterable
            v-model="queryParams.areaName"
            placeholder="请选择区域"
            clearable
            @change="changeArea"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.areaName"
              :value="item.areaName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 国家 -->
        <el-form-item label="国家">
          <el-select
            filterable
            v-model="queryParams.countryName"
            placeholder="请选择国家"
            clearable
          >
            <el-option
              v-for="(item, index) in countryList.filter(item => {
                return (
                  !queryParams.areaName || item.areaName == queryParams.areaName
                );
              })"
              :key="index"
              :label="item.countryName"
              :value="item.countryName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 操作 -->
        <el-form-item label=" ">
          <el-button type="primary" size="small" @click="doSearch"
            >查询</el-button
          >
          <el-button type="primary" size="small" @click="handleResetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <div class="table-btn" style="margin: 24px 0 12px 0">
        <el-button type="primary" size="small" @click="handleAddOrEdit('新增')"
          >信息录入</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        v-loading="tableLoading"
        highlight-current-row
        :border="true"
        :data="tableData"
        :header-cell-style="{ background: '#EFEFEF', color: '#000' }"
      >
        <!-- 序号 -->
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ getColumnIndex(scope.$index) }}
          </template>
        </el-table-column>
        <!-- 大区 -->
        <el-table-column
          prop="areaName"
          label="大区"
          min-width="90px"
          align="center"
        />
        <!-- 国家 -->
        <el-table-column
          prop="countryName"
          label="国家"
          min-width="90px"
          align="center"
        />
        <!-- 竞争对手直营网点数量 -->
        <el-table-column
          prop="directOutletsNumber"
          label="竞争对手直营网点数量"
          min-width="90px"
          align="center"
        />
        <!-- 竞争对手二级网点数量 -->
        <el-table-column
          prop="secondaryOutletsNumber"
          label="竞争对手二级网点数量"
          min-width="90px"
          align="center"
        />
        <!-- 销售经理 -->
        <el-table-column
          prop="saleManager"
          label="销售经理"
          min-width="90px"
          align="center"
        />
        <!-- 出口状态 -->
        <el-table-column
          prop="exitStatus"
          label="出口状态"
          min-width="90px"
          align="center"
        />
        <!-- 市场状态 -->
        <el-table-column
          prop="marketStatus"
          label="市场状态"
          min-width="90px"
          align="center"
        />
        <!-- 首都 -->
        <el-table-column
          prop="capital"
          label="首都"
          min-width="90px"
          align="center"
        />
        <!-- 人口 -->
        <el-table-column
          prop="population"
          label="人口"
          min-width="90px"
          align="center"
        />
        <!-- 更新时间 -->
        <el-table-column
          prop="updateTime"
          label="更新时间"
          min-width="160px"
          align="center"
        />
        <!-- 操作 -->
        <el-table-column
          label="操作"
          align="center"
          width="160px"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- 编辑 -->
            <el-button
              size="mini"
              type="text"
              @click="handleAddOrEdit('编辑', scope.row)"
              >编辑</el-button
            >
            <!-- 查看 -->
            <el-button
              size="mini"
              type="text"
              @click="handleAddOrEdit('查看', scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import listCurd from "@/mixins/listCurd";
import {
  getAreaCountryListApi,
  getInfoListApi
} from "@/api/saleTaskCollection";

export default {
  name: "ListPage",
  mixins: [listCurd],
  data() {
    return {
      // 区域
      areaList: [],
      // 国家
      countryList: [],
      // 搜索条件
      queryParams: {
        areaName: "", // 区域
        countryName: "" // 国家
      },
      // 列表数据接口
      listMethod: getInfoListApi
    };
  },
  created() {
    // 获取区域国家
    this.getAreaCountryList();
    // 获取表格数据
    this.getList();
  },
  methods: {
    // 获取地区国家列表
    async getAreaCountryList() {
      const res = await getAreaCountryListApi();
      this.areaList = res.data.saleAreaList || [];
      this.countryList = res.data.saleCountryList || [];
    },
    // 区域改变
    changeArea() {
      this.queryParams.countryName = "";
    },
    /**
     * 新增/编辑/查看
     * @param {String} operateType 操作类型 新增/编辑/查看
     * @param {Object} data 编辑的数据
     */
    handleAddOrEdit(operateType, data = {}) {
      this.$router.push({
        path: "/saleTaskCollection/infoListInput/detail",
        query: {
          operateType,
          baseInfoId: data.id,
          areaName: data.areaName,
          countryName: data.countryName
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-container {
  padding: 30px 20px 0 20px;
  border-bottom: 5px solid #efefef;
  ::v-deep .el-input {
    width: 150px;
  }
}
.table-container {
  padding: 24px 7px 0 23px;
}
</style>
